const DISCOUNT_CODE = 'RECOMENDADO10';

/**
 * Wraps the cart's "También te puede interesar" product-list so that adding one of those
 * products applies RECOMENDADO10 automatically, reusing the existing cart-discount-component
 * (same code path as a customer typing the code by hand) instead of duplicating its fetch/morph
 * logic. Scoped to this block only: listens for the bubbling shopify:cart:lines-update event,
 * which only reaches this element when the add happened inside it.
 */
class MvCartRecommendationsDiscount extends HTMLElement {
  /** @type {AbortController | undefined} */
  #abortController;

  connectedCallback() {
    this.#abortController = new AbortController();
    this.addEventListener('shopify:cart:lines-update', this.#onCartLinesUpdate, {
      signal: this.#abortController.signal,
    });
  }

  disconnectedCallback() {
    this.#abortController?.abort();
  }

  /** @param {CustomEvent & {action?: string, promise?: Promise<{detail?: {didError?: boolean}}>}} event */
  #onCartLinesUpdate = (event) => {
    if (event.action !== 'add' || !event.promise) return;

    event.promise
      .then(({ detail }) => {
        if (detail?.didError) return;
        this.#applyDiscount();
      })
      .catch(() => {});
  };

  #applyDiscount() {
    document.querySelectorAll('cart-discount-component').forEach((component) => {
      const form = component.querySelector('form');
      const input = component.querySelector('input[name="discount"]');
      if (!(input instanceof HTMLInputElement) || !form || typeof component.applyDiscount !== 'function') return;

      input.value = DISCOUNT_CODE;
      component.applyDiscount({
        preventDefault() {},
        stopPropagation() {},
        target: form,
      });
    });
  }
}

if (!customElements.get('mv-cart-recommendations-discount')) {
  customElements.define('mv-cart-recommendations-discount', MvCartRecommendationsDiscount);
}
